// extracted by mini-css-extract-plugin
export default {"native-id-container":"UserDetail_native-id-container__ldJuV","input-row":"UserDetail_input-row__348j4","actions":"UserDetail_actions__bPBkW"};